import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import ModalContainer from '../Modals/ModalContainer'
import { MUIFormTextInput } from '../@Common/Form/TextInput/FormTextInput'
import { hideModal, showErrorNotification, showSuccessNotification } from '../../redux/actions'

function PartnerRenameModal({
  partner, partnerListingsCount, onClickUpdatePartner, onClickClose,
}) {
  const dispatch = useDispatch()
  const [processing, setProcessing] = useState(false)

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      partnerName: partner.name,
    },
  })
  const watchedPartnerName = watch('partnerName')

  const handleUpdatePartner = handleSubmit(async (data) => {
    setProcessing(true)
    try {
      const result = await onClickUpdatePartner({
        ...partner,
        name: data.partnerName,
      })
      if (result.success) {
        dispatch(showSuccessNotification('Partner renamed successfully.'))
        dispatch(hideModal())
      } else {
        dispatch(showErrorNotification('Unable to rename partner.'))
      }
    } catch {
      dispatch(showErrorNotification('Unable to rename partner.'))
    } finally {
      setProcessing(false)
    }
  })

  const renderNote = () => {
    if (partnerListingsCount != null && partnerListingsCount > 1) {
      return `Note: This partner is linked to ${partnerListingsCount} listings. This update will impact reporting for all linked listings.`
    }
    return 'Note: This update will impact reporting for all linked listings.'
  }

  return (
    <ModalContainer
      title="Rename Partner"
      maxWidth="sm"
      fullWidth="true"
      modal
      onClose={onClickClose}
      processing={processing}
      actions={{
        primaryAction: {
          label: 'Update',
          onClick: handleUpdatePartner,
          disabled: !watchedPartnerName || watchedPartnerName === partner.name,
        },
        secondaryAction: { label: 'Cancel', onClick: onClickClose },
      }}
    >
      <Box>
        <Box>
          <MUIFormTextInput
            name="partnerName"
            control={control}
            label="Partner Name"
            gxid="partnerName"
            autoFocus
          />
          {(partnerListingsCount == null || partnerListingsCount > 0) && (
            <Typography
              variant="body2"
              sx={{
                mt: 0.5,
                px: 0.5,
                borderRadius: 0.5,
                fontSize: '.8rem',
                fontWeight: 400,
                lineHeight: 1.2,
              }}
            >
              {renderNote()}
            </Typography>
          )}
        </Box>
      </Box>
    </ModalContainer>
  )
}

PartnerRenameModal.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  partnerListingsCount: PropTypes.number,
  onClickUpdatePartner: PropTypes.func.isRequired,
  onClickClose: PropTypes.func.isRequired,
}

export default PartnerRenameModal
